import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getToken } from '../utils';
import { LoadingMode } from '../Components/LoadingMode';
import { LiaTimesSolid } from 'react-icons/lia';
import SelectInput from '../Components/SelectInput';

function ModalSelectAccount({ content }) {
  const [isSubmitting, setIsSubmitting] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { token: userToken } = getToken();

  const navigate = useNavigate();
  const {
    handleOpenandCloseModal,
    cxId,
    bidData,
    setBidData,
    handleToast,
    selectModalContent,
    trackModalState,
  } = content;

  const handleSubmit = (id) => {
    setIsSubmitting(id);

    setIsLoading(true);
  };

  const handleresponse = useCallback(
    (toastState, toastmessage, closeModalString) => {
      handleToast(toastState, toastmessage);
      setIsLoading(false);
      setIsSubmitting('');
      handleOpenandCloseModal(closeModalString);
    },
    [handleOpenandCloseModal, handleToast]
  );

  //Accepting direct offer
  useEffect(() => {
    const acceptOfferData = {
      cx_id: cxId,
      direct_accept: 1,
      account_id: selectModalContent?.id,
    };
    if (isSubmitting === 'accept') {
      const acceptOffer = async () => {
        try {
          await axios.post(
            `${process.env.REACT_APP_BASE_URL}/bid/accept`,
            acceptOfferData,
            { headers: { Authorization: `Bearer ${userToken}` } }
          );

          handleresponse(
            'success',
            'You have succesfully accepted an offer',
            'close'
          );
          navigate('/transactionrequest');
        } catch (error) {
          handleresponse('error', 'Network error please try again', 'accept');
          console.log(error);
        }
      };
      acceptOffer();
    }
  }, [
    userToken,
    isSubmitting,
    navigate,
    cxId,
    selectModalContent?.id,
    handleresponse,
  ]);

  //place bid
  useEffect(() => {
    const bidOfferData = {
      amount: bidData.amount,
      rate: bidData.rate,
      message: bidData.message,
      cx_transaction_id: cxId,
      account_id: selectModalContent?.id,
    };
    if (isSubmitting === 'bid') {
      const inputObject = {
        amount: '',
        rate: '',
        message: '',
      };
      const submitBid = async () => {
        try {
          await axios.post(
            `${process.env.REACT_APP_BASE_URL}/bid/store`,
            bidOfferData,
            {
              headers: { Authorization: `Bearer ${userToken}` },
            }
          );

          setBidData(inputObject);
          handleresponse(
            'success',
            'You have succesfully placed a bid',
            'close'
          );

          navigate('/transactionrequest');
        } catch (error) {
          console.log(error);

          handleresponse('error', 'Network error please try again', 'bid');
        }
      };
      submitBid();
    }
  }, [
    userToken,
    isSubmitting,
    setBidData,
    handleresponse,
    bidData.amount,
    bidData.rate,
    bidData.message,
    cxId,
    selectModalContent?.id,
    navigate,
  ]);

  return (
    <div className='flex flex-col gap-6 w-full md:w-[25rem] bg-p-wh py-8 rounded absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
      <h2 className='font-semibold text-base font-pin border-b-hf pb-2 px-2 md:px-6'>
        Bank Account
      </h2>

      <span
        className=' text-2xl text-s-bk cursor-pointer fixed right-6 top-6 hover:text-p-bk'
        onClick={() => handleOpenandCloseModal('close')}
      >
        <LiaTimesSolid />
      </span>
      <div className='px-2 md:px-6 flex flex-col gap-2'>
        <p className='text-p-bk/50 text-base font-normal font-pin'>
          Select bank account
        </p>
        <div className='w-full'>
          <SelectInput
            selectDropDownData={{
              optionString: '',
              textColor: 'black',
              selectModalContent: selectModalContent
                ? selectModalContent
                : null,
              handleOpenandCloseModal,
              open: 'selectpopup',
            }}
          />
        </div>
        <div className='flex flex-row items-center gap-6 mt-6'>
          <button
            type='button'
            className='text-p-bk px-2 md:px-6  hover:bg-s-bk/20 focus:bg-s-bk/20 py-2.5 font-semibold bg-f-bk rounded'
            onClick={() => handleOpenandCloseModal('offerdetails')}
          >
            Back
          </button>
          <button
            type='button'
            className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 px-4 py-2.5 w-full font-semibold disabled:bg-b-mct bg-b-mc rounded relative'
            disabled={isLoading ? isLoading : selectModalContent === undefined}
            onClick={
              trackModalState === 'bid'
                ? () => handleSubmit('bid')
                : trackModalState === 'accept'
                ? () => handleSubmit('accept')
                : null
            }
          >
            {trackModalState === 'bid'
              ? 'Place bid'
              : trackModalState === 'accept'
              ? 'Accept Offer'
              : null}
            {isLoading && <LoadingMode />}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalSelectAccount;
